import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import clinicAPI from "../../../services/clinicApi";
import { mediaUrl } from "../../../utils/clientHeroTheme";
import { HubScreen } from "../AdminPortal/HubPwa";
import aa from "../AdminPortal/adminApp.module.css";
import { Avatar } from "../../ui";
import { ROLE_LABEL } from "../AdminPortal/staffProfileShared";

const MENU = [
  {
    id: "extended",
    label: "Расширенные настройки",
    hint: "Данные, оформление, пароль",
    to: "/staff/app/profile/settings",
  },
];

export default function StaffProfileHub() {
  const navigate = useNavigate();
  const { profile, tenant } = useSelector((state) => state.auth);
  const [branding, setBranding] = useState(null);

  const load = useCallback(async () => {
    try {
      const data = await clinicAPI.getMyTrainerBranding();
      setBranding(data.branding || null);
    } catch {
      setBranding(null);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const photoSrc = mediaUrl(branding?.photo_url || profile?.photo_url);
  const coverSrc = mediaUrl(branding?.portal_cover_url);
  const accent = branding?.portal_accent_color || "var(--aa-accent)";

  return (
    <HubScreen
      title="Профиль"
      onBack={() => navigate("/staff/app/more")}
      backLabel="Ещё"
    >
      <section
        className={aa.staffProfileHero}
        style={
          coverSrc
            ? {
                backgroundImage: `linear-gradient(180deg, rgba(15,23,42,0.15), rgba(15,23,42,0.55)), url(${coverSrc})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }
            : {
                background: `linear-gradient(135deg, color-mix(in srgb, ${accent} 18%, #fff), var(--aa-surface))`,
              }
        }
      >
        <Avatar
          name={profile?.full_name || branding?.full_name || "?"}
          src={photoSrc}
          size="lg"
          className={aa.staffProfileHeroAvatar}
        />
        <div className={aa.staffProfileHeroText}>
          <h2 className={aa.staffProfileHeroName}>
            {profile?.full_name || branding?.full_name || "—"}
          </h2>
          <p className={aa.staffProfileHeroRole}>{ROLE_LABEL.trainer}</p>
          <p className={aa.staffProfileHeroMeta}>{profile?.email}</p>
          {tenant?.name ? (
            <p className={aa.staffProfileHeroClub}>{tenant.name}</p>
          ) : null}
        </div>
      </section>

      <nav className={aa.staffProfileMenu} aria-label="Разделы профиля">
        {MENU.map((item) => (
          <button
            key={item.id}
            type="button"
            className={aa.staffProfileMenuItem}
            onClick={() => navigate(item.to)}
          >
            <span className={aa.staffProfileMenuText}>
              <strong>{item.label}</strong>
              <span>{item.hint}</span>
            </span>
            <span className={aa.staffProfileMenuChevron} aria-hidden />
          </button>
        ))}
      </nav>
    </HubScreen>
  );
}
